import { Injectable } from '@angular/core';
import { PfeActionsService } from './../pfe-actions.service';
import { PfeNestedActions } from './nested-actions.model';

@Injectable()
export class PfeNestedActionsService {
  constructor(private pfeActionsService: PfeActionsService) {}
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  executeNestedActions = async (actionConfig: PfeNestedActions<any>): Promise<boolean> =>
    await this.pfeActionsService.executeActions(actionConfig.actions);
}
